module.exports = __webpack_public_path__ + "replay.2abd604e.png";